import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuItemModifier extends BaseFormModel<MenuItemModifier> {
    id: number;
    menuModifier: MenuModifier;
    additionalPrice: number;
    sortOrder: number;
    child: boolean;
}
